import { ArrowLeft, Upload } from 'lucide-react';
import { Button } from '../ui/Button';
import { CaseStatusBadge } from '../cases/CaseStatusBadge';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import type { Case, DocumentStatus } from '../../types';
import { DOCUMENT_STATUS_CONFIG } from '../../types';

interface CaseTopBarProps {
  caseData: Case;
  currentDocumentStatus?: DocumentStatus;
  onBack: () => void;
  onUploadDocuments: () => void;
  onDocumentStatusChange: (status: DocumentStatus) => void;
  isDocumentSelected: boolean;
  isDocumentFinalized: boolean;
}

export function CaseTopBar({
  caseData,
  currentDocumentStatus,
  onBack,
  onUploadDocuments,
  onDocumentStatusChange,
  isDocumentSelected,
  isDocumentFinalized,
}: CaseTopBarProps) {
  return (
    <div className="h-14 border-b border-border bg-white flex items-center justify-between px-4">
      {/* Left Section */}
      <div className="flex items-center gap-4">
        <button
          onClick={onBack}
          className="p-1.5 hover:bg-gray-100 rounded-md transition-colors"
          aria-label="Back to cases"
        >
          <ArrowLeft className="h-5 w-5 text-gray-600" />
        </button>

        <div className="flex items-center gap-3">
          <span className="font-medium text-sm">{caseData.name}</span>
          <CaseStatusBadge status={caseData.status} />
        </div>
      </div>

      {/* Right Section */}
      <div className="flex items-center gap-3">
        <Button
          variant="outline"
          size="sm"
          onClick={onUploadDocuments}
        >
          <Upload className="h-4 w-4 mr-1.5" />
          Upload Documents
        </Button>

        {isDocumentSelected && !isDocumentFinalized && currentDocumentStatus && (
          <Select
            value={currentDocumentStatus}
            onValueChange={(value: string) => onDocumentStatusChange(value as DocumentStatus)}
          >
            <SelectTrigger className="w-[180px]" size="sm">
              <SelectValue placeholder="Status" />
            </SelectTrigger>
            <SelectContent>
              {(['needs_redaction', 'redacted'] as DocumentStatus[]).map((status) => (
                <SelectItem key={status} value={status}>
                  <div className="flex items-center gap-2">
                    <div
                      className="w-2 h-2 rounded-full"
                      style={{ backgroundColor: DOCUMENT_STATUS_CONFIG[status].color }}
                    />
                    {DOCUMENT_STATUS_CONFIG[status].label}
                  </div>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}

      </div>
    </div>
  );
}
